import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import catchErrors from 'utils/commands/catchErrors';
import { pushToast } from 'containers/ToastManager/actions';
import { addWorkspace } from 'Workspace/Admin/store/actions';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { workspace, meta } = action;

  const workspaceCreate = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_CREATE,
    name: workspace.name,
    description: workspace.description,
  });

  if (workspaceCreate.type === constants.RTM_WORKSPACE_CREATE_OK) {
    const response = workspaceCreate.response.workspace;
    yield put(addWorkspace(response));
  } else {
    yield put(
      pushToast({
        type: 'simple',
        message: <FormattedMessage {...messages.failedIamTeamCreate} />,
      })
    );
  }

  if (meta && Array.isArray(meta.callbacks)) {
    meta.callbacks.forEach((callback) => callback());
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_CREATE, catchErrors, sendRequest, connection);
}
